(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/parse-to-decimals.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/parse-to-decimals.js');
"use strict";


function parseToDecimals(value, decimalDelimiter) {
  if (typeof value === 'number') {
    const decimalString = value.toFixed(2);
    return decimalDelimiter ? decimalString.replace('.', decimalDelimiter) : decimalString;
  }
  return value;
}
if (svs.isServer) {
  module.exports = parseToDecimals;
} else {
  svs.sportsbook.sbtech_api_impl.utils.parseToDecimals = parseToDecimals;
}

 })(window);